import React from 'react';
import FormInput from '../../library/form/components/FormInput';
import FormTag from "../../library/form/components/FormTag";
import FormSH from "../../library/form/components/FormSH";
import { UiViewContent } from "../../library/layout/Index";
import SarasChipContainer from '../../library/repeater/list/SarasChipContainer';

const DocItemSelector = (props) => {
    const { formObject, viewData } = props;

    return (
        <UiViewContent>
            <div className="">
                <div className="uiFlexBox3">
                    <div  className="uiFlexBox3">

                        <FormInput formObject={formObject} rowKey="" headerKey="tagSelector" className="uiInput uiTagInput" alwaysRender={true} placeholder="Select..."
                            action={{ InputType: "ac", paramName: "newTag", actionId: 'save', 
                            acMethod: "%dataList.acMethod", 
                            acDepCtrl:{ dtid: '%dataList.valLDT', level: '%dataList.level' }, 
                            actionParam: { "updatetag": "1" }, 
                            refreshMode:"self" }}
                        />

                        <FormSH formObject={formObject} rowKey="" headerKey="tagSelector"
                            action={{ actionId: "new", paramName: "tagSH",  actionName: "Item", actionParam:{}, containerKey: "popup" }}
                                >
                        </FormSH>

                    </div>
                    <div className="uiSelectedChip">
                        <SarasChipContainer>
                            {
                                Object.values(viewData).sort((a, b) => a.sortKey - b.sortKey).map((row, index) => (
                                    row.rowKey !== "tagSelector"?(<FormTag formObject={formObject} rowKey={row.rowKey} 
                                        action={{ paramName: "tag", actionParam:{ "updatetag": "1" }, refreshMode:"self"  }}
                                    />):''
                                ))
                            }
                        </SarasChipContainer>
                    </div>
                </div>
            </div>
        </UiViewContent>
    )
}

export default DocItemSelector